import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyPersonalSettingsAccessTokensRoute: InvariantJiraRoute = {
	name: 'legacy-personal-settings-access-tokens',
	path: '/plugins/servlet/oauth/users/access-tokens',
};
